/**
 * Media Popup Mixin
 *
 * TODO: SAC: This has grown to be more than initially designed. As such, it should now be refactored a bit. Basically
 *       this class should become an action & event dispatcher, dispersing to proper player classes and triggering
 *       appropriate events.
 *
 * 1) Move each player into its own class instead of doing 'if player x else if player y ...' all over.
 * 2) Video's, etc., are now used for more than initially designed, so the 'start', 'complete', etc. actions should not
 *    be handled here (pass in a callback or have initiators listen to triggered events).
 *
 * User: scarlson
 * Date: 01/21/2013
 * Time: 11:21 PM
 */

/**
 * TODO: this shouldn't be used anymore and it can be removed
 */
define(function (require) {
  'use strict';

  // Exposing MobileEC as a global variable to be able to use as callback for mobile devices (Android and iOS)
  window.MobileEC = {};

  var Alert = require('common/views/Alert'),
    BlockUI = require('blockui'),
    Const = require('common/Const'),
    EasyDialog = require('easyDialog'),
    CommonFunctions = require('common/CommonFunctions'),
    ECVideoPopup = require('common/templates/media/ECVideoPopup.html'),
    ECVideoPopupFn = _.template(ECVideoPopup),
    flashMediaPopup = require('common/templates/media/FlashMediaPopup.html'),
    flashMediaPopupFn = _.template(flashMediaPopup),
    genericVideoPopup = require('common/templates/media/GenericVideoPopup.html'),
    genericVideoPopupFn = _.template(genericVideoPopup),
    newsPopup = require('common/templates/media/NewsPopup.html'),
    newsPopupFn = _.template(newsPopup),
    _courseType = null,
    _currentCourseId = null,
    _complete = null,
    _playerTitle = null,
    _startTime = null,
    _endTime = null,
    _pageSource = null,
    _maxFuncRetries = 2,
    _englishCentralReady = false,
    _englishCentralError = null,
    _startTimes = [],
    _stopTimes = [],
    __validPersonId = function (personId) {
      var person = oeApp.getData('person');
      return person && person.id && person.id == personId;
    },
    __isTokenDataValid = function (tokens) {
      return (
        tokens.loginToken &&
        tokens.accessToken &&
        __validPersonId(tokens.personId)
      );
    },
    _initializeVideos = function () {
      MobileEC._savePersonCourseMobile = _savePersonCourseMobile;
    },
    // Setting Token cookies for 1 day
    __setECTokenInCookie = function () {
      var dfd = jQuery.Deferred();

      $.ajax({
        type: 'POST',
        data: JSON.stringify({ tokenType: 'JWT' }),
        dataType: 'json',
        url: '/ectokens',
        success: function (data, textStatus, jqXHR) {
          var token = data.loginToken;
          var access_token = data.accessToken;
          var person = oeApp.getData('person');
          var personId = person.id;

          CommonFunctions.setCookie('__oe_pid', personId, 1);
          CommonFunctions.setCookie('__oe_ec', token, 1);
          CommonFunctions.setCookie('__oe_ec_access', access_token, 1);
          dfd.resolve();
        },
        error: function (jqXHR, textStatus, errorThrown) { },
      });

      return dfd.promise();
    },
    __getECTokens = function () {
      var person_id = CommonFunctions.getCookie('__oe_pid');
      var ec_token = CommonFunctions.getCookie('__oe_ec');
      var ec_access_token = CommonFunctions.getCookie('__oe_ec_access');
      return {
        loginToken: ec_token,
        accessToken: ec_access_token,
        personId: person_id,
      };
    },
    initialize = function () {
      var swfobject = require('swfobject');
    },
    __saveECProgress = function (data) {
      var complete = false;
      var isWatchComplete = false;
      var isLearnComplete = false;
      var isSpeakComplete = false;

      if (data.activities) {
        _.each(data.activities, function (activity) {
          switch (activity.activityType) {
            case 'watchActivity':
              isWatchComplete = activity.completed;
              break;
            case 'learnActivity':
              isLearnComplete = activity.completed;
              break;
            case 'speakActivity':
              isSpeakComplete = activity.completed;
              break;
            default:
              console.log(
                'Error: activity not recognized: ' + activity.activityType
              );
          }
        });
        complete = isWatchComplete && isLearnComplete && isSpeakComplete;
      }
      var payload = {
        timeOnTask: Math.ceil((new Date().getTime() - _startTime) / 1000),
        statusId: complete ? 2 : 1,
      };
      _savePersonCourse(payload, complete);
    },
    __reportEnglishCentralVideoProgress = function (mediaData, retries) {
      retries = retries || 0;

      if (retries > _maxFuncRetries) {
        return new Alert({
          title: i18n.alert.titleError,
          text:
            'Error retrieving activity progress. Saving course progress failed.',
          container: 2,
        });
      }

      var ecTokens = __getECTokens();

      if (!__isTokenDataValid(ecTokens)) {
        __setECTokenInCookie().done(function () {
          __reportEnglishCentralVideoProgress(mediaData, ++retries);
        });
        return;
      }

      var reportCardUrl = oeApp.getData('common').englishCentralReportCardUrl;

      $.ajax({
        type: 'GET',
        url: reportCardUrl + '/rest/report/dialog/' + mediaData + '/progress?useNewContentWords=true',
        headers: {
          ACCEPT:
            'application/vnd.englishcentral-v1+json,application/json;q=0.9,*/*;q=0.8',
          Authorization: 'JWT ' + ecTokens.accessToken,
        },
        statusCode: {
          401: function () {
            console.log('401 found in EC report card progress');
            __setECTokenInCookie().done(function () {
              __reportEnglishCentralVideoProgress(mediaData, ++retries);
            });
          },
        },
      }).done(function (data) {
        __saveECProgress(data);
      });
    },
    _playEnglishCentralVideoMobile = function (videoID) {
      if (oeApp.isAndroidDevice() && oeApp.isOpenEnglishDevice() && oeAndroid) {
        oeAndroid.playEC(videoID, 'MobileEC._savePersonCourseMobile');
        return true;
      } else if (oeApp.isIosDevice()) {
        window.open(
          'playec://lp2?dialogid=' +
          videoID +
          '&callback=' +
          'MobileEC._savePersonCourseMobile'
        );
        return true;
      }
      return false;
    },
    _launchECHTML5Player = function (mediaData, retries) {
      retries = retries || 0;
      var ec_token = __getECTokens().loginToken;

      if (retries > _maxFuncRetries) {
        new Alert({
          title: i18n.alert.titleError,
          text: i18n.videoPlayer.errors.ecInitFailed,
          container: 2,
        });
        return;
      }

      if (!ec_token) {
        __setECTokenInCookie().done(function () {
          _launchECHTML5Player(mediaData, ++retries);
        });
        return;
      }

      $.easydialog({
        closeColor: 'grey',
        closeOnEscape: false,
        content: ECVideoPopupFn({
          i18n: i18n,
          i18nPage: i18n.media.genericVideoPopup,
          title: _playerTitle,
        }),
        dialogClass: 'ec-popup',

        onClosed: function () {
          __reportEnglishCentralVideoProgress(mediaData);
          $('#ec-player').html('');
        },
        onStart: function (e) {
          _startTime = new Date().getTime();

          var retries = 0;

          var loadWidget = function () {
            if (retries > _maxFuncRetries) {
              $.easydialog.close('default');
              new Alert({
                title: i18n.alert.titleError,
                text: i18n.videoPlayer.errors.ecInitFailed,
                container: 2,
              });
              return;
            }
            $('#ec-player').html('').hide();

            $('#ec-loading').show();

            ECSDK.loadWidget('player', {
              partnerKey: Const.ENGLISH_CENTRAL_APP_ID,
              partnerSdkToken: ec_token,
              dialogId: mediaData,
              lang: oeApp.getData('person').preferredLang,
              container: 'ec-player',
            });
          };

          ECSDK.setLoginErrorHandler(function () {
            __setECTokenInCookie().done(function () {
              ec_token = __getECTokens().loginToken;
              loadWidget(++retries);
            });
          });

          ECSDK.setOnReadyHandler(function () {
            $('#ec-loading').hide();
            $('#ec-player').show();
          });

          loadWidget();
        },
      });
    },
    _playEnglishCentralVideo = function (blockEl, mediaData) {
      if (_playEnglishCentralVideoMobile(mediaData)) {
        return;
      } else if (typeof ECSDK !== 'undefined') {
        _launchECHTML5Player(mediaData, 0);
      } else {
        new Alert({
          title: i18n.alert.titleError,
          text: i18n.videoPlayer.errors.ecInitFailed,
          container: 2,
        });
      }
    },
    _playTestProp = function (blockEl, mediaData) {
      var me = this;

      // alert('SACCHECK12');
      $.easydialog({
        closeColor: 'grey',
        closeOnEscape: false,
        content: flashMediaPopupFn({
          i18n: i18n,
          url: mediaData.url,
          title: _playerTitle,
        }),

        onClosed: function () {
          var payload = {},
            timeOnTask = Math.ceil((new Date().getTime() - _startTime) / 1000),
            complete = true;

          payload.timeOnTask = timeOnTask;
          payload.statusId = complete ? 2 : 1;

          _savePersonCourse(payload, complete);
        },
      });
    },
    _playFlashMedia = function (blockEl, mediaData) {
      var me = this;

      // alert('SACCHECK12');
      $.easydialog({
        closeColor: 'grey',
        closeOnEscape: false,
        content: flashMediaPopupFn({
          i18n: i18n,
          url: mediaData.url,
          title: _playerTitle,
        }),

        onClosed: function () {
          var payload = {},
            timeOnTask = Math.ceil((new Date().getTime() - _startTime) / 1000),
            complete = timeOnTask >= mediaData.time * 0.9 || _complete;

          payload.timeOnTask = timeOnTask;
          payload.statusId = complete ? 2 : 1;

          _savePersonCourse(payload, complete);
        },
      });
    },
    _startPractice = function () {
      _startTime = new Date().getTime();
    },
    _closePractice = function () {
      _endTime = new Date().getTime();
      $.easydialog.close('default');
    },
    _completePractice = function () {
      _complete = true;
    },
    _newsTranslate = function (word, callback) {
      var data = { word: word };
      $.getJSON('/tools/translate', data)
        .success(function (response) {
          if (callback && typeof callback === 'function') {
            callback(response);
          }
        })
        .fail(function () {
          new Alert({
            title: i18n.alert.titleError,
            text: i18n.errors.unablePerformAction,
            container: 2,
          });
        });
    },
    _onPracticeModalClosed = function () {
      if (_startTime != null) {
        // make sure they clicked the start button
        if (_endTime == null) {
          // they could have just closed the window, set an end time
          _endTime = new Date().getTime();
        }
        var payload = {};
        payload.timeOnTask = Math.ceil((_endTime - _startTime) / 1000);
        payload.statusId = _complete ? 2 : 1;
        _savePersonCourse(payload, _complete);
      }
    },
    _resizeIframe = function () {
      var iframe = $('#news-wrapper iframe'),
        iframeHeight = iframe.contents().find('body').height();

      //Change the height
      iframe.css('height', iframeHeight);

      //No Scrolls
      iframe.contents().find('body').css('overflow', 'hidden');
    },
    _playNews = function (blockEl, mediaData, courseType) {
      _startTime = new Date().getTime();
      var domain = window.location.hostname.split('.').reverse();
      if (domain[0] !== 'localhost') {
        document.domain =
          domain.length > 1 ? domain[1] + '.' + domain[0] : domain[0];
      }

      window.TCAPI = {
        startPractice: _startPractice,
        closePractice: _closePractice,
        completePractice: _completePractice,
        translateWord: _newsTranslate,
        resizeIframe: _resizeIframe,
      };

      var width;
      switch (courseType) {
        case 'Idioms':
          width = 615;
          break;
        case 'News':
        default:
          width = 750;
          break;
      }

      // alert('SACCHECK16');
      $.easydialog({
        closeOnEscape: false,
        content: newsPopupFn({
          i18n: i18n,
          title: _playerTitle,
          width: width,
        }),
        onComplete: function () {
          var iframe = $('iframe');
          iframe.attr('src', mediaData.url);
        },
        onClosed: function () {
          _onPracticeModalClosed();
        },
      });
    },
    _playGenericVideo = function (blockEl, mediaData) {
      // alert('SACCHECK18');
      $.easydialog({
        closeColor: 'grey',
        closeOnEscape: false,
        content: genericVideoPopupFn({
          i18n: i18n,
          i18nPage: i18n.media.genericVideoPopup,
          title: _playerTitle,
        }),
        video: null,

        _getVideoEl: function () {
          return document.getElementById('video');
        },

        _detectBandwidth: function () {
          var deferred = $.Deferred(),
            testImage = new Image(),
            testImageSize = 34334,
            startTime = new Date().getTime();
          // start time is appended for cache busting
          testImage.src = '/images/img30.jpg?' + startTime;
          testImage.onload = function () {
            // Do the calculations for bandwidth
            var endTime = new Date().getTime(),
              duration = (endTime - startTime) / 1000,
              bitsLoaded = testImageSize * 8,
              speedBps = (bitsLoaded / duration).toFixed(2),
              speedKbps = (speedBps / 1024).toFixed(2),
              speedMbps = (speedKbps / 1024).toFixed(2);
            deferred.resolve(speedMbps);
          };

          return deferred.promise();
        },

        _updateVideoBuffer: function () {
          if (this.video) {
            var currentBuffer = this.video.buffered.end(0),
              totalDuration = this.video.duration,
              percentBuffered = (100 * currentBuffer) / totalDuration;

            // Update width of buffer span
            $('div.scrubber > span.buffer').css('width', percentBuffered + '%');

            // While there is still more to buffer, set up to
            // update the buffer span again in 500 ms
            if (currentBuffer < totalDuration) {
              setTimeout(_.bind(this._updateVideoBuffer, this), 500);
            }
          }
        },

        _updateVideoProgress: function () {
          if (this.video) {
            var currentPosition = this.video.currentTime,
              totalDuration = this.video.duration,
              percentWatched = (100 * currentPosition) / totalDuration;

            // Update the width of the viewed span
            $('div.scrubber > span.current-time').css(
              'width',
              percentWatched + '%'
            );
          }
        },

        _displayVideoError: function () {
          new Alert({
            title: i18n.alert.titleError,
            text: i18n.videoPlayer.errors.videoIdMissing,
            container: 2,
          });
        },

        _setupVideoControls: function () {
          var me = this;

          // Set up to start showing video buffer once video is loaded
          $('#video').on('loadedmetadata', function () {
            setTimeout(function () {
              me._updateVideoBuffer();
            }, 150);
          });

          $('#video').on('timeupdate', _.bind(me._updateVideoProgress, this));

          // Remove native HTML5 video controls
          me.video.removeAttribute('controls');

          // Hide the loading video screen
          $('#playerHolder').hide();
          // Ensure video controls are hidden
          $('div.video-controls').hide();
          // Show the video
          $('video').show();
          // Fade in the big play button
          $('div.video-bigplay-btn').fadeIn(500);

          $('div.video-player-wrapper')
            .hover(
              function () {
                $('div.video-controls').stop().fadeIn();
              },
              function () {
                $('div.video-controls').stop().fadeOut();
              }
            )
            .click(function (event) {
              if (event.target !== this) return;
              me._togglePlayPause();
            });

          $('#video').click(_.bind(me.onPlayBtnClick, this));
          $('div.video-bigplay-btn').click(_.bind(me.onPlayBtnClick, this));
          $('div.video-controls > div.play-btn').click(
            _.bind(me.onPlayBtnClick, this)
          );
          $('div.video-controls > div.pause-btn').click(
            _.bind(me.onPauseBtnClick, this)
          );
          $('div.video-controls > div.skip-fwd-btn').click(
            _.bind(me.onSkipFwdBtnClick, this)
          );
          $('div.video-controls > div.skip-back-btn').click(
            _.bind(me.onSkipBackBtnClick, this)
          );
          $('div.video-controls > div.fullscreen-btn').click(
            _.bind(me.onFullscreenBtnClick, this)
          );
          $('div.video-controls > div.audio-enabled-btn').click(
            _.bind(me._toggleAudio, this)
          );
          $('div.video-controls > div.audio-muted-btn').click(
            _.bind(me._toggleAudio, this)
          );
        },

        _togglePlayPause: function () {
          var isPlaying = !(this.video.paused || this.video.ended);
          $('div.video-bigplay-btn').toggle();
          $('div.play-btn').toggle();
          $('div.pause-btn').toggle();
          if (isPlaying) {
            this.video.pause();
          } else {
            this.video.play();
          }
        },

        _toggleAudio: function () {
          this.video.muted = !this.video.muted;
          $('div.video-controls > div.audio-enabled-btn').toggle();
          $('div.video-controls > div.audio-muted-btn').toggle();
        },

        onPlayBtnClick: function () {
          this._togglePlayPause();
        },

        onPauseBtnClick: function () {
          this._togglePlayPause();
        },

        onSkipFwdBtnClick: function () {
          // Skip ahead 5 seconds
          this.video.currentTime = this.video.currentTime + 5;
        },

        onSkipBackBtnClick: function () {
          // Skip back 5 seconds
          this.video.currentTime = this.video.currentTime - 5;
        },

        onFullscreenBtnClick: function () {
          if ($.isFunction(this.video.requestFullscreen)) {
            this.video.requestFullscreen();
          } else if ($.isFunction(this.video.webkitEnterFullscreen)) {
            this.video.webkitEnterFullScreen();
          } else if ($.isFunction(this.video.mozRequestFullScreen)) {
            this.video.mozRequestFullScreen();
          } else if ($.isFunction(this.video.msRequestFullScreen)) {
            this.video.msRequestFullscreen();
          }
        },

        onComplete: function () {
          var me = this;

          me.video = me._getVideoEl();

          var videoSrc = mediaData.replace(
            '{{lang}}',
            commonConfig.getNLSLanguage()
          );

          me._detectBandwidth().done(function (speedMbps) {
            if (me.video) {
              // TODO: research more bitrates, etc... best practices for web video encoding
              if (speedMbps < 3) {
                videoSrc = videoSrc.replace('{{bitrate}}', '360');
              } else {
                videoSrc = videoSrc.replace('{{bitrate}}', '720');
              }
              me.video.setAttribute('src', videoSrc);

              me._setupVideoControls();

              $('video').bind('ended', function () {
                // Trigger backbone events that we've watched a video.
                // This is taken from _savePersonCourse in mediaPopup.js
                Backbone.trigger(
                  'media:played:' + _courseType + ':' + _currentCourseId,
                  true
                );
                Backbone.trigger(
                  'media:played:' + _courseType,
                  _currentCourseId,
                  true
                );
                Backbone.trigger(
                  'media:played',
                  _courseType,
                  _currentCourseId,
                  true
                );
              });
            } else {
              this._displayVideoError();
            }
          });
        },

        onClosed: function () {
          if (this.video) {
            this.video.pause();
            this.video.src = '';
            // For Firefox compatibility
            this.video.load();
            this.video = null;
          }
        },
      });
    },
    _savePersonCourse = function (results, complete) {
      var onComplete = function () {
        Backbone.trigger(
          'media:played:' + _courseType + ':' + _currentCourseId,
          complete
        );
        Backbone.trigger(
          'media:played:' + _courseType,
          _currentCourseId,
          complete
        );
        Backbone.trigger(
          'media:played',
          _courseType,
          _currentCourseId,
          complete
        );
      };

      if (
        _courseType == Const.LESSON_TYPE.Immersion ||
        _courseType == Const.LESSON_TYPE.News ||
        _courseType == Const.LESSON_TYPE.Idioms
      ) {
        _savePersonCourseImmersion(results, complete, onComplete);
      } else if (_courseType == Const.LESSON_TYPE.Lesson) {
        _savePersonCourseLesson(results, complete, onComplete);
      } else {
        onComplete();
      }

      if (complete && _pageSource && _pageSource == 'home') {
        Backbone.trigger('practice:complete');
      }
    },
    _savePersonCourseMobile = function (timeOnTask, complete) {
      var payload = {
        timeOnTask: timeOnTask,
        statusId: complete ? 2 : 1,
      };

      // Dont save person course if course is already complete
      if (!_complete) {
        _savePersonCourse(payload, complete);
      }
    },
    _savePersonCourseImmersion = function (results, complete, onComplete) {
      if (!results) {
        results = {
          timeOnTask: 0,
          statusId: 1,
        };
      }

      var payload = {
        course: {
          id: _currentCourseId,
        },
        timeOnTask: results.timeOnTask,
        statusId: results.statusId,
      };

      $.ajax({
        data: JSON.stringify(payload),
        dataType: 'json',
        type: 'PUT',
        url: '/course/savepersoncourse',
      })
        .done(function (data) {
          // send data for subtle notification
          window.dispatchEvent(
            new CustomEvent('person-progress-saved', { detail: data })
          );
          onComplete();
        })
        .fail(function () {
          new Alert({
            title: i18n.alert.titleError,
            text: i18n.errors.unablePerformAction,
            container: 2,
          });
        });
    },
    _savePersonCourseLesson = function (results, complete, onComplete) {
      var url = complete
        ? '/progress/finish/lesson/' + _currentCourseId
        : '/course/init/' + _currentCourseId;

      $.post(url)
        .done(function () {
          onComplete();
        })
        .fail(function () {
          new Alert({
            title: i18n.alert.titleError,
            text: i18n.errors.unablePerformAction,
            container: 2,
          });
        });
    },
    _shouldPlayFlash = function (sourceId) {
      return (
        sourceId == Const.SOURCE_TYPE_ENUM.flashLesson ||
        sourceId == Const.SOURCE_TYPE_ENUM.test_prep
      );
    },
    methods = {
      playVideo: function (blockEl, mediaData, complete, data) {
        var configuration = {
          courseType: data.type ? data.type : '',
          courseId: data.id ? data.id : '',
          sourceId: data.sourceId ? data.sourceId : '',
          playerTitle: data.title ? data.title : '',
          transcript: data.transcript ? data.transcript : '',
          autoInit: data.autoInit ? data.autoInit : 0,
        };

        _courseType = configuration.courseType;
        _currentCourseId = configuration.courseId;
        _complete = false;
        _pageSource = data.pageSource;
        _playerTitle = configuration.playerTitle || '&nbsp;';
        _startTime = new Date().getTime();
        _endTime = null;

        if (
          mediaData &&
          configuration.sourceId == Const.SOURCE_TYPE_ENUM.englishCentral
        ) {
          _playEnglishCentralVideo(blockEl, mediaData);
        } else if (
          mediaData &&
          configuration.sourceId == Const.SOURCE_TYPE_ENUM.generic
        ) {
          _playGenericVideo(blockEl, mediaData);
        } else if (
          mediaData &&
          configuration.sourceId == Const.SOURCE_TYPE_ENUM.flashLesson
        ) {
          _playFlashMedia(blockEl, mediaData);
        } else if (
          mediaData &&
          configuration.sourceId == Const.SOURCE_TYPE_ENUM.test_prep
        ) {
          _playTestProp(blockEl, mediaData);
        } else if (
          configuration.courseType === 'News' ||
          configuration.courseType === 'Idioms'
        ) {
          _playNews(blockEl, mediaData, configuration.courseType);
        } else if (!mediaData) {
          new Alert({
            title: i18n.alert.titleError,
            text: i18n.videoPlayer.errors.videoIdMissing,
            container: 2,
          });
        } else {
          new Alert({
            title: i18n.alert.titleError,
            text:
              i18n.videoPlayer.errors.unknownSourceType +
              ' sourceId=' +
              configuration.sourceId,
            container: 2,
          });
        }
      },
    };

  return {
    initialize: function (view) {
      _initializeVideos();
      _.extend(view, methods);
    },
  };
});



//////////////////
// WEBPACK FOOTER
// ./js/common/mixins/mediaPopup.js
// module id = 775
// module chunks = 26 27 28